<template>
  <Modal ref="modal">
    <h2 class="box__title">
      {{ $t('moveApplicationModal.title') }}
    </h2>
    <p>
      {{
        $t('moveApplicationModal.description', {
          name: application.name,
        })
      }}
    </p>
    <Error :error="error"></Error>
    <div class="margin-bottom-2">
      <Dropdown
        v-model="selectedWorkspaceId"
        :show-search="true"
        :placeholder="$t('moveApplicationModal.selectWorkspace')"
        :fixed-items="true"
      >
        <DropdownItem
          v-for="ws in otherWorkspaces"
          :key="ws.id"
          :name="ws.name"
          :value="ws.id"
        >
          {{ ws.name }}
        </DropdownItem>
      </Dropdown>
    </div>
    <div class="actions actions--right">
      <Button type="secondary" @click="hide()">
        {{ $t('action.cancel') }}
      </Button>
      <Button
        :loading="loading"
        :disabled="!selectedWorkspaceId || loading"
        @click="move()"
      >
        {{ $t('moveApplicationModal.confirm') }}
      </Button>
    </div>
  </Modal>
</template>

<script>
import { notifyIf } from '@onedesk/modules/core/utils/error'
import error from '@onedesk/modules/core/mixins/error'

export default {
  mixins: [error],
  props: {
    application: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedWorkspaceId: null,
      loading: false,
    }
  },
  computed: {
    otherWorkspaces() {
      return this.$store.getters['workspace/getAll'].filter(
        (ws) => ws.id !== this.application.workspace.id
      )
    },
  },
  methods: {
    show() {
      this.selectedWorkspaceId = null
      this.hideError()
      this.$refs.modal.show()
    },
    hide() {
      this.$refs.modal.hide()
    },
    async move() {
      if (!this.selectedWorkspaceId || this.loading) return

      const targetWorkspace = this.$store.getters['workspace/getAll'].find(
        (ws) => ws.id === this.selectedWorkspaceId
      )
      if (!targetWorkspace) return

      this.loading = true
      this.hideError()

      try {
        await this.$store.dispatch('application/move', {
          application: this.application,
          targetWorkspace,
        })
        if (this.$refs.modal) {
          this.$refs.modal.hide()
        }
      } catch (e) {
        notifyIf(e, 'application')
        this.handleError(e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
